export { StudentSettingsGeneralPage } from "./StudentSettingsGeneralPage"
export type {
    StudentGeneralSettingsField,
    StudentSettingsGeneralPageProps,
    UIStudentGeneralSettings,
    UIStudentSubscriptionSummary,
} from "./StudentSettingsGeneralPage"
